import styled from 'styled-components';
export var arrowSize = 8;
export var StyledArrow = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledArrow",
  componentId: "core-12_20_2__sc-1epxw7u-0"
})(["position:absolute;background:inherit;width:", "px;height:", "px;transform:rotate(45deg);"], arrowSize, arrowSize);
//# sourceMappingURL=OverlayArrow.styles.js.map